import React from 'react';
import { BiArrowFromLeft, BiArrowFromRight } from 'react-icons/bi';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import Logo from '../../composant/Logo/Logo';
import wiLogo from '../../ressources/Logo/wi.png';
import RubriquesNavigationAdmin from '../../composant/Navigation/RubriquesNavigationAdmin/RubriquesNavigationAdmin';
import RubriquesNavigationClient from '../../composant/Navigation/RubriquesNavigationClient/RubriquesNavigationClient';
import * as url from '../../ressources/glossaires/glossaire_liens_pages';
import * as s from '../../ressources/StyleGlobal/StyleGlobal';
import EnTete from '../EnTete/EnTete';
import styles from './Menu.module.scss';
const Menu = (props) => {
  const interfaceAdmin = useSelector(
    (state) => state.authentifie.interfaceAdmin
  );

  let attachedClasses = [
    s.d_flex,
    s.flex_column,
    styles.Menu,
    styles.Fermer,
    styles.RubliquesNavigationScroll,
  ];

  let commutateurClasses = [];

  if (interfaceAdmin) {
    commutateurClasses.push(styles.CommutateurMenuAdmin);
  } else {
    commutateurClasses.push(styles.CommutateurMenu);
  }

  let iconeFleche = <BiArrowFromLeft size={30} />;

  let fondGris = [styles.FondGrisMenu];

  if (props.ouvert) {
    attachedClasses = [styles.Menu, styles.Ouvert];
    commutateurClasses.push(styles.CommutateurOuvert);
    iconeFleche = <BiArrowFromRight size={30} />;
  }
  return (
    <>
      <div
        className={[
          attachedClasses.join(' '),
          styles.RubliquesNavigationScroll,
        ].join(' ')}
      >
        {interfaceAdmin ? null : (
          <Link to={url.accueil} className={styles.LogoLink}>
            <Logo src={wiLogo} />
          </Link>
        )}
        <div className={[].join(' ')}>
          <EnTete />
          <nav>
            {interfaceAdmin ? (
              <RubriquesNavigationAdmin />
            ) : (
              <RubriquesNavigationClient />
            )}
          </nav>
        </div>
        {interfaceAdmin ? (
          <Link to={url.projet}>
            <Logo src={wiLogo} />
          </Link>
        ) : null}
      </div>
      <span
        className={commutateurClasses.join(' ')}
        onClick={props.commutateur}
      >
        {iconeFleche}
      </span>
      <span className={fondGris} onClick={props.commutateur} />
    </>
  );
};

export default Menu;
